import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getClasses, joinClassByCode, postMembers } from "../../../redux/actions/classes";
import styles from "./CSSFiles/MyClass.module.css";
import JoinClassModal from "./JoinClassModal";
import { useTranslation } from 'react-i18next';

const MyCourse = () => {
  const {t} = useTranslation();
    return (
      <div className={styles.dropdown_menu1}>
        <ul>
          <div className={styles.menu1}>
            <Link to="/courses" style={{ textDecoration: "none" }}>
              <li style={{ marginTop: 6, marginBottom: 6, color: "#555555" }}>{t("common.myCourses")}</li>
            </Link>
          </div>
        </ul>
      </div>
    );
  }

export default MyCourse;
